import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import Form from "./Form";
import { Table } from "./Table";

export interface IWorkStreamCategory {
  id?: number;
  category_Name: string;
  added_By?: string;
  added_On?: Date | null;
  updated_By?: string;
  updated_On?: Date | null;
}

export interface IModel {
  open: boolean;
  singleData: IWorkStreamCategory;
}

export const EmptyWorkStreamCategory: IWorkStreamCategory = {
  id: 0,
  category_Name: "",
  added_By: "",
  added_On: null,
  updated_By: "",
  updated_On: null,
};

const WorkStreamCategories = () => {
  const toast = useRef<any>(null);
  const [reload, setReload] = useState(false);
  const [modal, setModal] = useState<IModel>({ open: false, singleData: EmptyWorkStreamCategory });

  return (
    <>
      <Toast ref={toast} />
      <Table reload={reload} toast={toast} setModal={setModal} />
      <Form open={modal.open} singleData={modal.singleData} toast={toast} reload={reload} setReload={setReload} hideDialog={() => setModal({ open: false, singleData: EmptyWorkStreamCategory })} />
    </>
  );
};

export default WorkStreamCategories;
